<template>
  <section :class="{ section: !isLoadingFull }">
    <b-loading v-if="isLoadingFull" :isFullPage="false" active>
      <CustomLoaderAnimation />
    </b-loading>
    <template v-else>
      <b-loading :active="isLoading" />

      <div class="is-flex is-align-items-center mb-25">
        <div class="cursor-pointer" @click="goToProfiles()">
          <b-icon
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
            icon="arrow-left-thick"
            size="is-medium"
          />
        </div>
        <h1 class="title is-size-4 has-text-color-7 ml-10">
          {{ General.PERMISSIONS_MANAGEMENT_BY_PROFILE }}
        </h1>
      </div>
      <b-table
        stickyHeader
        hoverable
        :data="permissions"
        class="table-profiles permissions-table"
        height="65vh"
      >
        <b-table-column v-slot="props" sticky :label="General.PERMISSIONS">
          <span class="large-column is-capitalized has-text-color-7">{{
            props.row.name.replace(/_/g, " ").toLowerCase()
          }}</span>
        </b-table-column>
        <b-table-column
          v-for="item in profiles"
          v-slot="props"
          :key="`profile_${item.id}`"
          :label="item.name"
          cellClass="vertical-middle"
        >
          <div class="centered-custom">
            <b-checkbox
              v-model="item.permissions"
              :nativeValue="props.row"
              size="is-medium"
              @input="() => changeProfile(item)"
            />
          </div>
        </b-table-column>
      </b-table>
    </template>
  </section>
</template>

<script>
import { App, General } from "@/utils/constants";
import CustomLoaderAnimation from "@/components/CustomLoaderAnimation";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProfileManagement",
  components: { CustomLoaderAnimation },
  data() {
    return {
      App,
      General,
      isLoading: false,
      isLoadingFull: false,
      profiles: [],
      profilesPermissions: {}
    };
  },
  computed: {
    ...mapGetters(["getProfiles", "getPermission", "isContrast"]),
    permissions() {
      return this.getPermission.list.map(permission => ({
        name: permission.name,
        id: permission.id
      }));
    },
    profilesFormat() {
      return this.getProfiles.results.map(profile => ({
        ...profile,
        permissions: profile.permissions.map(permission => ({
          name: permission.name,
          id: permission.id
        }))
      }));
    }
  },
  watch: {
    profilesFormat(value) {
      this.profiles = value;
    }
  },
  async beforeMount() {
    this.isLoadingFull = true;
    await this.profileRequest({ page: 1, paginator_count: 2e3, search: "" });
    await this.getAllPermissionsRequest({
      page: 1,
      paginator_count: 900,
      order_by: "id"
    });
    this.profiles = this.profilesFormat;
    this.isLoadingFull = false;
  },
  methods: {
    ...mapActions([
      "profileRequest",
      "getAllPermissionsRequest",
      "updateProfileRequest"
    ]),
    async changeProfile(profile) {
      this.isLoading = true;
      await this.updateProfileRequest({
        name: profile.name,
        profile_x_permission: true,
        permissions: profile.permissions.map(permission => permission.id),
        profileId: profile.id
      });
      this.isLoading = false;
    },
    goToProfiles() {
      this.$router.push("/app/admin/perfis");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
.section {
  background-color: $color-1;
  padding-top: 20px;
}

.table-profiles {
  max-width: 81vw;
  @media screen and (max-width: $tablet) {
    max-width: 95vw;
  }
  th div {
    width: 110px;
    text-align: center;
  }
  .large-column {
    width: 220px;
    display: flex;
  }
  .centered-custom {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: calc(0.75em - 1px);
  }
}
</style>

<style lang="scss">
.table-profiles {
  th div {
    width: 110px;
    text-align: center;
    justify-content: center;
  }
  .vertical-middle {
    vertical-align: middle;
  }
}
</style>
